import { Expose } from "class-transformer";

export class ExternalUrlSessionDto {
  @Expose()
  id!: string;

  @Expose()
  url!: string;
}
